import { UserInterface } from './models';

export function emailSignature(user: UserInterface): string {
  return `<br>


<table
  class="msonormaltable"
  border="0"
  cellspacing="0"
  cellpadding="0"
  style="border-collapse: collapse"
>
  <tbody>
    <tr>
      <td
        width="84"
        valign="top"
        style="
          width: 63.3pt;
          border-width: medium 1pt medium medium;
          border-style: none solid none none;
          border-color: currentcolor windowtext currentcolor currentcolor;
          border-image: none;
          padding: 0cm 5.4pt;
        "
      >
        <div
          style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif"
        >
          <a href="http://www.columbus-cruise-management.com/"
            ><span
              lang="en-us"
              style="
                font-size: 9pt;
                font-family: poppins;
                text-decoration: none;
              "
              ><img
                border="0"
                height="68"
                id="picture_x0020_109"
                style="width: 0.7291in; height: 0.7083in"
                alt="image001.jpg"
                src="cid:image001.jpg@logo" /></span></a
          >
        </div>
      </td>
      <td width="445" valign="top" style="width: 333.6pt; padding: 0cm 5.4pt">
        <div
          style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif"
        >
          <b
            ><span
              lang="en-us"
              style="
                font-size: 10pt;
                font-family: poppins;
                color: rgb(0, 50, 93);
              "
              >${user?.username}
              </span
          ></b>
        </div>
        <div
          style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif"
        >
          <span
            lang="en-us"
            style="font-size: 9pt; font-family: poppins; color: rgb(0, 50, 93)"
            >${user?.title}
          </span>
        </div>
        <div
          style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif"
        >
          <span lang="en-us" style="font-size: 5pt; font-family: poppins"
            ><br /></span
          ><span style="font-size: 9pt; font-family: poppins"
            >M ${user?.tel}</span>
        </div>
        <div
          style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif"
        >
          <span style="font-size: 9pt; font-family: poppins"
            >E<span class="apple-converted-space">&nbsp;</span
            ><a href="mailto:${user?.email}"
              ><span style="text-decoration: none"
                >${user?.email}</span
              ></a
            >
          </span>
        </div>
        <div
          style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif"
        >
          <span style="font-size: 5pt; font-family: poppins"><br /></span
          ><span lang="de-de" style="font-size: 9pt; font-family: poppins"
            >COLUMBUS Reisen GmbH & Co KG.
          </span>
        </div>
        <div
          style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif"
        >
          <span lang="de-de" style="font-size: 9pt; font-family: poppins"
            >Handelskai 265 1020 Vienna, Austria
          </span>
        </div>
        <div
          style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif"
        >
          <span style="font-size: 9pt; font-family: poppins"
            ><a href="http://www.columbus-cruise-management.com/"
              ><span style="text-decoration: none"
                >www.columbus-cruise-management.com</span
              ></a
            >
          </span>
        </div>
         <div
          style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif"
        >
          <span style="font-size: 5pt; font-family: poppins"><br /></span
          ></div>
        <div
          style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif"
        >
          <a href="https://www.facebook.com/columbus.reisen.at"
            ><b
              ><span
                lang="en-us"
                style="
                  font-size: 10pt;
                  font-family: poppins;
                  text-decoration: none;
                "
                ><img
                  border="0"
                  height="19"
                  id="picture_x0020_110"
                  alt="image002.png"
                  style="width: 0.1979in; height: 0.1979in"
                  src="cid:image002.png@facebook" /></span></b></a
          ><b
            ><span style="font-size: 10pt; font-family: poppins"
              >&nbsp;<span class="apple-converted-space"
                >&nbsp;&nbsp;</span
              ></span
            ></b
          ><a href="https://www.instagram.com/columbus_reisen/"
            ><b
              ><span
                lang="en-us"
                style="
                  font-size: 10pt;
                  font-family: poppins;
                  text-decoration: none;
                "
                ><img
                  border="0"
                  height="19"
                  id="picture_x0020_111"
                  alt="image003.png"
                  style="width: 0.1979in; height: 0.1979in"
                  src="cid:image003.png@instagram" /></span></b></a
          ><b
            ><span style="font-size: 10pt; font-family: poppins"
              >&nbsp;&nbsp;<span class="apple-converted-space">&nbsp;</span></span
            ></b
          ><a
            href="https://www.linkedin.com/company/columbus-ihr-reiseb%c3%bcro"
            ><b
              ><span
                lang="en-us"
                style="
                  font-size: 9pt;
                  font-family: poppins;
                  text-decoration: none;
                "
                ><img
                  border="0"
                  height="19"
                  id="picture_x0020_112"
                  alt="image004.png"
                  style="width: 0.1979in; height: 0.1979in"
                  src="cid:image004.png@linkedIn" /></span></b></a>
        </div>
      </td>
    </tr>
  </tbody>
</table>
<div style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif">
  <span style="font-size: 5pt; font-family: poppins"><br></span>
</div>
<div style="margin: 0cm; font-size: 11pt; font-family: aptos, sans-serif">
  <span style="font-size: 8pt; font-family: poppins; text-transform:uppercase"
    >uid: atu 10903209, fn nr.: 5351w, handelsgericht wien</span
  >
</div>
<br>
<br>
`;
}
